import React, { Component } from "react";
import { onDownload } from "../utils/utils";

class About extends Component {
  render() {
    if (this.props.data) {
      var name = this.props.data.name;
      var profilepic = "images/" + this.props.data.image;
      var bio = this.props.data.bio;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone = this.props.data.phone;
      var email = this.props.data.email;
      var resumeDownload = this.props.data.resumedownload;
    }

    return (
      <section id="about">
        <div className="row">
          <div className="three columns center">
            <img
              className="profile-pic"
              src={profilepic}
              alt="Billede af Mathias Bischoff"
            />
          </div>
          <div className="nine columns main-col">
            <h2>About me</h2>

            <p>{bio}</p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Information</h2>
                <p className="address">
                  <span>{name}</span>
                  <br />
                  <span>
                    {street}
                    <br />
                    {city} {state}, {zip}
                  </span>
                  <br />
                  <span>{phone}</span>
                  <br />
                  <span>{email}</span>
                </p>
              </div>
              <div className="columns download">
                {
                  <p>
                    <a
                      aria-disabled
                      onClick={() =>
                        onDownload(
                          "mathias-bischoff-cv.pdf",
                          "mb-cv-13-12-22.pdf"
                        )
                      }
                      className="button"
                    >
                      <i className="fa fa-download"></i>Download Resume
                    </a>
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
